export const NEXT_DEPLOYMENT_ID = "next";
export const CURRENT_DEPLOYMENT_ID = "current";
export const BLACKFIRE_ID_VARIABLE = "env:BLACKFIRE_SERVER_ID";

/**
 * Is this rejection the API's final word for the session?
 *
 * 404 ("this environment has never deployed") and 403 ("you may not read it")
 * do not change until something else in the app changes them, so a fetch that
 * ends in one is settled and must not be re-asked (CON-1655). Everything else
 * — 5xx, a dropped connection, a timeout, a rejection that never reached
 * `rejectWithValue` and so carries no code — is transient: the next mount has
 * to be allowed to try again, or one blip leaves the panels broken for the
 * rest of the session.
 *
 * Same split the thunks use to decide what is worth logging.
 */
export const isSettledDeploymentErrorCode = (code?: number) =>
  code === 404 || code === 403;
